<template>
  <v-container fill-height fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" md="7">
        <v-stepper v-model="step_value">
          <validation-observer v-slot="{ valid }">
            <v-card :loading="loading" :disabled="loading">
              <v-stepper-header>
                <template v-for="(s, index) in steps">
                  <v-stepper-step
                    color="secondary"
                    :complete="step_value > index + 1"
                    :step="index + 1"
                    :key="index + 1"
                  >
                    {{ s.name }}
                  </v-stepper-step>
                  <v-divider
                    :key="index"
                    v-if="index !== Object.keys(steps).length - 1"
                  ></v-divider>
                </template>
              </v-stepper-header>

              <v-toolbar flat color="primary" dark class="justify-center">
                <v-toolbar-title>{{ step().name }}</v-toolbar-title>
              </v-toolbar>
              <v-row>
                <v-col
                  style="background: #ffd2bd"
                  v
                  class="pa-8"
                  v-html="step().description"
                >
                </v-col>
              </v-row>
              <v-divider></v-divider>
              <v-stepper-items>


                <!--       user info step         -->
                <v-stepper-content step="1">
                  <v-row>
                    <v-col>
                      <validation-observer>
                        <v-form v-if="step_value === 1">
                          <v-row>
                            <!--          Fist name field                  -->
                            <v-col cols="6" md="3">
                              <validation-provider
                                v-slot="{ errors }"
                                rules="required"
                              >
                                <v-text-field
                                  required
                                  v-model="item.info.first_name"
                                  v-bind:label="$t('register.first_name_text_field')"
                                  :error-messages="errors"
                                />
                              </validation-provider>
                            </v-col>

                            <!--            last name field                -->
                            <v-col cols="6" md="3">
                              <validation-provider
                                  v-slot="{ errors }"
                                  rules="required"
                              >
                                <v-text-field
                                    required
                                    v-model="item.info.last_name"
                                    v-bind:label="$t('register.last_name_text_field')"
                                    :error-messages="errors"
                                />
                              </validation-provider>
                            </v-col>

                            <!--           email                 -->
                            <v-col cols="12" md="6">
                              <validation-provider v-slot="{ errors }">
                                <v-text-field
                                  v-model="item.info.email"
                                  :disabled="true"
                                  v-bind:label="$t('login.email_input')"
                                  :error-messages="errors"
                                />
                              </validation-provider>
                            </v-col>

                            <!--           Country name                 -->
                            <v-col cols="6" md="3">
                              <validation-provider
                                  v-slot="{ errors }"
                                  rules="required"
                              >
                                <v-select
                                    required
                                    v-model="item.info.country"
                                    v-bind:label="$t('register.country')"
                                    :items="countries"
                                    item-value="value"
                                    item-text="name"
                                    :error-messages="errors"
                                />
                              </validation-provider>
                            </v-col>

                            <!--            gender section                -->
                            <v-col cols="6" md="3">
                              <validation-provider
                                  v-slot="{ errors }"
                                  rules="required"
                              >
                                <v-select
                                    required
                                    v-model="item.info.gender"
                                    v-bind:label="$t('profile.gender')"
                                    :items="genders"
                                    item-value="value"
                                    item-text="name"
                                    :error-messages="errors"
                                />
                              </validation-provider>
                            </v-col>

                            <!--             phone section               -->
                            <v-col cols="6" md="3">
                              <validation-provider
                                  v-slot="{ errors }"
                                  rules="required"
                              >
                                <v-text-field
                                    v-bind:label="$t('login.phone_number_input')"
                                    :error-messages="errors"
                                    v-model="item.info.phone"
                                />
                              </validation-provider>
                            </v-col>


                            <!--           birthday section                 -->
                            <v-col cols="6" md="3">
                              <v-menu
                                  ref="menu"
                                  v-model="menu"
                                  :close-on-content-click="false"
                                  transition="scale-transition"
                                  offset-y
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <validation-provider
                                      v-slot="{ errors }"
                                      rules="required"
                                  >

                                    <v-text-field
                                        v-model="item.info.birthday"
                                        label="Birthday date"
                                        prepend-icon="mdi-calendar"
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                        required
                                        :error-messages="errors"
                                    ></v-text-field>
                                  </validation-provider>
                                </template>
                                <v-date-picker
                                    v-model="item.info.birthday"
                                    :max="(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)"
                                    min="1950-01-01"
                                ></v-date-picker>
                              </v-menu>
                            </v-col>



                          </v-row>
                        </v-form>
                      </validation-observer>
                    </v-col>
                  </v-row>
                </v-stepper-content>


                <!--       film details         -->
                <v-stepper-content step="2">
                  <v-row>
                    <v-col>
                      <validation-observer>
                        <v-form v-if="step_value === 2">
                          <v-row>
                            <v-col cols="12" md="6">
                              <validation-provider
                                v-slot="{ errors }"
                                rules="required"
                              >
                                <v-text-field
                                  required
                                  v-model="item.movie.name"
                                  v-bind:label="$t('profile.media_title')"
                                  :error-messages="errors"
                                />
                              </validation-provider>
                            </v-col>
                            <v-col cols="12" md="6">
                              <validation-provider
                                v-slot="{ errors }"
                                rules="required"
                              >
                                <v-select
                                  required
                                  v-model="item.movie.category"
                                  v-bind:label="$t('stepper.category')"
                                  :items="parts"
                                  item-text="name"
                                  item-value="value"
                                  :error-messages="errors"
                                />
                              </validation-provider>
                            </v-col>
                            <v-col cols="12">
                              <validation-provider
                                v-slot="{ errors }"
                                rules="required"
                              >
                                <v-textarea
                                  required
                                  v-model="item.movie.description"
                                  v-bind:label="$t('stepper.details')"
                                  outlined
                                  :error-messages="errors"
                                />
                              </validation-provider>
                            </v-col>
                          </v-row>
                        </v-form>
                      </validation-observer>
                    </v-col>
                  </v-row>
                </v-stepper-content>

                <!--      crew section          -->
                <v-stepper-content step="3">
                  <v-row>
                    <v-col>
                      <template v-if="step_value === 3">
                        <validation-observer>
                          <v-form>
                            <v-row>
                              <v-col cols="12">
                                <template v-for="(s, index) in item.movie.crew">
                                  <v-card
                                    color=""
                                    class="ma-3 pa-4"
                                    :key="index"
                                    elevation="2"
                                    :disabled="index === 0"
                                  >
                                    <v-row>

                                      <!--          Fist name field                  -->
                                      <v-col cols="6" md="3">
                                        <validation-provider
                                            v-slot="{ errors }"
                                            rules="required"
                                        >
                                          <v-text-field
                                              required
                                              v-model="s.first_name"
                                              v-bind:label="$t('register.first_name_text_field')"
                                              :error-messages="errors"
                                          />
                                        </validation-provider>
                                      </v-col>

                                      <!--            last name field                -->
                                      <v-col cols="6" md="3">
                                        <validation-provider
                                            v-slot="{ errors }"
                                            rules="required"
                                        >
                                          <v-text-field
                                              required
                                              v-model="s.last_name"
                                              v-bind:label="$t('register.last_name_text_field')"
                                              :error-messages="errors"
                                          />
                                        </validation-provider>
                                      </v-col>

                                      <!--           email                 -->
                                      <v-col cols="12" md="6">
                                        <validation-provider v-slot="{ errors }"
                                                             rules="required|email"
                                        >
                                          <v-text-field
                                              v-model="s.email"
                                              v-bind:label="$t('login.email_input')"
                                              :error-messages="errors"
                                          />
                                        </validation-provider>
                                      </v-col>

                                      <!--           Country name                 -->
                                      <v-col cols="6" md="3">
                                        <validation-provider
                                            v-slot="{ errors }"
                                            rules="required"
                                        >
                                          <v-select
                                              required
                                              v-model="s.country"
                                              v-bind:label="$t('register.country')"
                                              :items="countries"
                                              item-value="value"
                                              item-text="name"
                                              :error-messages="errors"
                                          />
                                        </validation-provider>
                                      </v-col>

                                      <!--            gender section                -->
                                      <v-col cols="6" md="3">
                                        <validation-provider
                                            v-slot="{ errors }"
                                            rules="required"
                                        >
                                          <v-select
                                              required
                                              v-model="s.gender"
                                              v-bind:label="$t('profile.gender')"
                                              :items="genders"
                                              item-value="value"
                                              item-text="name"
                                              :error-messages="errors"
                                          />
                                        </validation-provider>
                                      </v-col>

                                      <!--             rule section               -->
                                      <v-col
                                          cols="12"
                                          :md="s.type === 6 ? 3 : 6"
                                      >
                                        <validation-provider
                                            v-slot="{ errors }"
                                            rules="required"
                                        >
                                          <v-select
                                              v-bind:label="
                                              $t('profile.cast_rule')
                                            "
                                              :items="
                                              index === 0
                                                ? crew_type
                                                : crew_type_prime
                                            "
                                              v-model="s.type"
                                              item-text="name"
                                              item-value="value"
                                              :error-messages="errors"
                                          ></v-select>
                                        </validation-provider>
                                      </v-col>
                                      <v-col
                                          cols="12"
                                          v-if="s.type === 6"
                                          md="3"
                                      >
                                        <validation-provider
                                            v-slot="{ errors }"
                                            rules="required"
                                        >
                                          <v-text-field
                                              :error-messages="errors"
                                              v-bind:label="
                                              $t('stepper.rule_message')
                                            "
                                              v-model="s.type_other"
                                          ></v-text-field>
                                        </validation-provider>
                                      </v-col>

                                      <!--           birthday section                 -->
                                      <v-menu
                                          ref="menu"
                                          v-model="s.menu"
                                          :close-on-content-click="false"
                                          transition="scale-transition"
                                          offset-y
                                          min-width="auto"
                                      >
                                        <template v-slot:activator="{ on, attrs }">
                                          <validation-provider
                                              v-slot="{ errors }"
                                              rules="required"
                                          >

                                            <v-text-field
                                                v-model="s.birthday"
                                                label="Birthday date"
                                                prepend-icon="mdi-calendar"
                                                readonly
                                                v-bind="attrs"
                                                v-on="on"
                                                required
                                                :error-messages="errors"
                                            ></v-text-field>
                                          </validation-provider>
                                        </template>
                                        <v-date-picker
                                            v-model="s.birthday"
                                            :max="(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)"
                                            min="1950-01-01"
                                        ></v-date-picker>
                                      </v-menu>


                                    </v-row>
                                    <v-card-actions>
                                      <v-btn
                                        v-if="index !== 0"
                                        color="error"
                                        @click="remove_crew(index)"
                                      >
                                        {{ $t("stepper.delete_crew") }}
                                      </v-btn>
                                    </v-card-actions>
                                  </v-card>
                                  <v-divider :key="index" />
                                </template>
                              </v-col>

                              <v-col cols="12">
                                <v-btn
                                  block
                                  color="secondary"
                                  @click="add_crew"
                                >
                                  {{ $t("stepper.add_crew") }}
                                </v-btn>
                              </v-col>
                            </v-row>
                          </v-form>
                        </validation-observer>
                      </template>
                    </v-col>
                  </v-row>
                </v-stepper-content>

                <!--      upload film section          -->
                <v-stepper-content step="4">
                  <v-row>
                    <v-col>
                      <template v-if="step_value === 4">
                        <validation-observer>
                          <v-form>
                            <v-card>
                              <uploader
                                :default_link="links[0]"
                                :url= "$store.state.upload_url"
                                @upload_succeed="upload_succeed"
                                @re_upload="re_upload"
                                @is_uploading="is_uploading"
                                type="0"
                                upload_type="2"
                                :accept="
                                  'video/* , .mkv'
                                "
                              >
                              </uploader>
                            </v-card>
                          </v-form>
                        </validation-observer>
                      </template>
                    </v-col>
                  </v-row>
                </v-stepper-content>

                <!--       upload extra files section         -->
                <v-stepper-content step="5">
                  <v-row>
                    <v-col>
                      <template v-if="step_value === 5">
                        <validation-observer>
                          <v-form>
                            <v-row class="pa-4">
                              <v-col cols="12" md="6">
                                <v-card>
                                  <v-card-title>{{
                                    $t("stepper.title_behind")
                                  }}</v-card-title>
                                  <v-card-text>
                                    <uploader
                                      :default_link="links[1]"
                                      :url= "$store.state.upload_url"
                                      v-bind:text="$t('stepper.text_behind')"
                                      icon="mdi-camera"
                                      @upload_succeed="upload_succeed"
                                      @is_uploading="is_uploading"
                                      @re_upload="re_upload"
                                      upload_type="1"
                                      type="1"
                                      :accept="'image/*'"
                                    ></uploader>
                                  </v-card-text>
                                </v-card>
                              </v-col>
                              <v-col cols="12" md="6">
                                <v-card>
                                  <v-card-title>{{
                                    $t("stepper.title_poster")
                                  }}</v-card-title>
                                  <v-card-text>
                                    <uploader
                                      :default_link="links[4]"
                                      :url= "$store.state.upload_url"
                                      v-bind:text="$t('stepper.text_poster')"
                                      icon="mdi-format-paint"
                                      @upload_succeed="upload_succeed"
                                      @is_uploading="is_uploading"
                                      @re_upload="re_upload"
                                      upload_type="1"
                                      type="4"
                                      :accept="'image/* , .pdf , .psd'"
                                    ></uploader>
                                  </v-card-text>
                                </v-card>
                              </v-col>
                              <v-col cols="12" md="6">
                                <v-card>
                                  <v-card-title>{{
                                    $t("stepper.title_trailer")
                                  }}</v-card-title>
                                  <v-card-text>
                                    <uploader
                                      :default_link="links[2]"
                                      :url= "$store.state.upload_url"
                                      v-bind:text="$t('stepper.text_trailer')"
                                      icon="mdi-file-video"
                                      @upload_succeed="upload_succeed"
                                      @is_uploading="is_uploading"
                                      @re_upload="re_upload"
                                      upload_type="1"
                                      type="2"
                                      :accept="'video/* , .mkv'"
                                    ></uploader>
                                  </v-card-text>
                                </v-card>
                              </v-col>
                              <v-col cols="12" md="6">
                                <v-card>
                                  <v-card-title>{{
                                    $t("stepper.text_script")
                                  }}</v-card-title>
                                  <v-card-text>
                                    <uploader
                                      :default_link="links[3]"
                                      :url= "$store.state.upload_url"
                                      v-bind:text="$t('stepper.title_script')"
                                      icon="mdi-script-text"
                                      @upload_succeed="upload_succeed"
                                      @is_uploading="is_uploading"
                                      @re_upload="re_upload"
                                      upload_type="1"
                                      type="3"
                                      :accept="'.pdf, .docx, .doc, .html'"
                                    ></uploader>
                                  </v-card-text>
                                </v-card>
                              </v-col>
                            </v-row>
                          </v-form>
                        </validation-observer>
                      </template>
                    </v-col>
                  </v-row>
                </v-stepper-content>

              </v-stepper-items>
              <v-spacer></v-spacer>

              <!--       button section         -->
              <v-card-actions class="justify-md-space-between">
                <v-btn
                  color="secondary"
                  @click="step_value -= 1"
                  :disabled="uploading || step_value === 1"
                >
                  <v-icon> {{ $route.params.lang === 'en' ? 'mdi-chevron-left'  : 'mdi-chevron-right' }}</v-icon>
                  {{ $t("stepper.previous_step") }}
                </v-btn>
                <v-btn
                  color="secondary"
                  @click="next_step(valid)"
                  :disabled="
                    (step_value === 4
                      ? !uploaded
                      : !valid) || uploading
                  "
                >
                  {{ next_text }}
                  <v-icon> {{ $route.params.lang === 'en' ? 'mdi-chevron-right'  : 'mdi-chevron-left' }}</v-icon>
                </v-btn>
              </v-card-actions>

            </v-card>
          </validation-observer>
        </v-stepper>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
  extend,
} from "vee-validate";
import { required} from "vee-validate/dist/rules";
import Uploader from "./Uploader";
import axios from "axios";
// import FormData from "form-data";
import i18n from "../../i18n";

setInteractionMode("eager");

extend("required", {
  ...required,
  message: () => i18n.t("login.required"),
});

export default {
  name: "Stepper",
  components: {
    Uploader,
    ValidationProvider,
    ValidationObserver,
  },
  data: () => {
    return {
      links: [null, null, null, null, null],
      step_value: 1,
      loading: false,
      uploading: false,
      steps_valid: [true, true, true, true, true],
      uploaded: false,
      menu: false,
      countries: [],
      item: {
        info: {
          first_name:"",
          last_name:"",
          email:"",
          phone: "",
          country:"",
          birthday:"",
          gender: null,
        },
        movie: {
          only_extra_part: false,
          document: "",
          name: "",
          category: null,
          description: "",
          crew: [],
          extras: [],
        },
      },
    };
  },
  mounted() {
    this.api_call()
    let context = this
    // Fetch all countries
    axios({
      method: 'get',
      url: 'https://restcountries.eu/rest/v2/all',
      headers: { }
    })
        .then(function (response) {
          response.data.forEach((el)=>{
              context.countries.push(el.name)
          })
        })
  },
  methods: {
    api_call() {
      this.loading = true;
      // Get User Data Api Call
      let config = {
        method: "get",
        url: this.$store.state.base_url+"/auth/user/",
        headers: {
          Authorization: "token " + localStorage.getItem("token"),
        },
      };
      let context = this;
      axios(config)
          .then(function (response) {
            context.item.info = response.data;
            context.loading = false;
          })
          .catch(function () {
            context.$router.push({name: "Login"});
            context.loading = false;
          });
    },

    upload_succeed(e) {
      if (e.type == 0) {
        this.uploaded = true;
        this.item.movie.document = e.res.id;
        this.links[0] = e.res.file;
      } else {
        this.item.movie.extras.push({ document: e.res.id, type: e.type });
        this.links[parseInt(e.type)] = e.res.file;
      }
    },

    re_upload(e) {
      if (e == 0) {
        this.uploaded = false;
      } else {
        let i = -1;

        this.item.movie.extras.forEach((it, index) => {
          if (it.type === e) {
            i = index;
          }
        });
        if (i !== -1)
          this.item.movie.extras = this.item.movie.extras.splice(i, 1);
      }
    },

    is_uploading(e) {
      this.uploading = e;
    },

    calculate_crew() {
      if (this.item.movie.crew.length === 0) {
        let type = 1;
        this.item.movie.crew.push({
          type: type,
          first_name: this.item.info.first_name,
          last_name: this.item.info.last_name,
          email: this.item.info.email,
          country: this.item.info.country,
          gender: this.item.info.gender,
          birthday: this.item.info.birthday
        });
      }
    },

    step() {
      return this.steps[this.step_value - 1];
    },

    next_step() {
      if (this.step_value === 5) {
        let context = this;
        this.loading = true;
        console.log(this)
        //Create data object
        let data = new FormData()
        data.append("user",JSON.stringify(this.item.info))
        let movie_object = this.item.movie
        delete Object.assign(movie_object, {['cast']: movie_object['crew'] })['crew'];
        delete Object.assign(movie_object, {['attachment']: movie_object['extras'] })['extras'];
        data.append("movie",JSON.stringify(movie_object))

        let config = {
          method: "post",
          url: this.$store.state.base_url + "/submission/movie/create/",
          headers: {
            Authorization: "token " + localStorage.getItem("token"),
          },
          data: data,
        };
        axios(config)
          .then(function () {
            context.$router.push(context.$route.params.lang+'/success')
            context.loading = false;
          })
          .catch(function () {
            context.loading = false;
          });
      } else {
        this.step_value += 1;
        if (this.step_value === 3) this.calculate_crew();
      }
    },

    add_crew() {
      this.item.movie.crew.push({
        type: null,
        first_name: "",
        last_name: "",
        email: "",
        country: "",
        gender: "",
        birthday: ""
      });
    },

    remove_crew(index) {
      this.item.movie.crew.splice(index, 1);
    },
  },
  computed: {
    steps: function () {
      return this.steps_main
    },

    parts: function () {
      let parted = i18n.t("stepper.static.parts")
      return this.item.movie.only_extra_part ? parted[7] : parted.slice(0,6);
    },

    crew_type: function () {
      return i18n.t("stepper.static.crew_type");
    },

    crew_type_prime: function () {
      return i18n.t("stepper.static.crew_type_prime");
    },

    genders: function () {
      return i18n.t("stepper.static.genders");
    },

    steps_main: function(){
      return [
        {
          name: i18n.t("stepper.steps_main.director_title"),
          index: 0,
          description: i18n.t("stepper.steps_main.director_description"),
        },
        {
          name: i18n.t("stepper.steps_main.media_title"),
          index: 1,
          description: i18n.t("stepper.steps_main.media_description"),
        },
        {
          name: i18n.t("stepper.steps_main.casts_title"),
          index: 2,
          description: i18n.t("stepper.steps_main.casts_description"),
        },
        {
          name: i18n.t("stepper.steps_main.upload_title"),
          index: 3,
          description: i18n.t("stepper.steps_main.upload_description"),
        },
        {
          name: i18n.t("stepper.steps_main.extra_title"),
          index: 4,
          description: i18n.t("stepper.steps_main.extra_description"),
        },
      ]
    },

    steps_extra: function (){
      return [
        {
          name: i18n.t("stepper.steps_main.type_title"),
          index: 0,
          description: i18n.t("stepper.steps_main.type_description"),
        },
        {
          name: i18n.t("stepper.steps_extra.writer_title"),
          index: 1,
          description: i18n.t("stepper.steps_extra.writer_description"),
        },
        {
          name: i18n.t("stepper.steps_main.media_title"),
          index: 2,
          description: i18n.t("stepper.steps_main.media_description"),
        },
        {
          name: i18n.t("stepper.steps_main.casts_title"),
          index: 3,
          description: i18n.t("stepper.steps_main.casts_description"),
        },
        {
          name: i18n.t("stepper.steps_extra.script_upload_title"),
          index: 4,
          description: i18n.t("stepper.steps_extra.script_upload_description"),
        },
      ]
    },

    next_text: function () {
      if (
        this.step_value === 5
      ) {
        return i18n.t('stepper.send_button');
      } else {
        return i18n.t('stepper.next_button');
      }
    },


  },
};

</script>

<style scoped>
.no-spacing {
  word-spacing: 0;
}
</style>
